import React from 'react'
import VerifyMaill from '../../Components/tutor/VerifyMail'
function VerifyMail() {
  return (
    <div>
      <VerifyMaill/>
    </div>
  )
}

export default VerifyMail
